import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import MainLayout from "../layouts/mainLayout";
import PermissionManagement from "./PermissionManagement";

// Main Layout
const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  loader,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const timmerRef = useRef();
  useEffect(() => {
    timmerRef.current = setTimeout(() => {
      setIsLoading(loader);
    }, 300);
    return () => {
      clearTimeout(timmerRef.current);
    };
  }, [loader]);
  return (
    <Route
      {...rest}
      component={(props) => {
        let children = <></>;
        if (!isAuthenticated) {
          return <Redirect to="/login" />;
        } else if (isLoading) {
          children = (
            <MainLayout>
              <></>
            </MainLayout>
          );
        } else {
          children = (
            <MainLayout>
              <Component {...props} />
            </MainLayout>
          );
        }
        return (
          <>
            <PermissionManagement {...rest} />
            {children}
          </>
        );
      }}
    />
  );
};

const mapStateToProps = (state) => {
  const isAuthenticated = state.login.loginFlag;
  const loader = state.userPermissions.isUserPermissionLoading;

  return {
    isAuthenticated,
    loader,
    // userPermissions, isSuperAdmin
  };
};

export default connect(mapStateToProps)(PrivateRoute);
